import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 mr-3" }
const _hoisted_2 = {
  key: 0,
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_3 = {
  key: 1,
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "text-sm font-medium" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-sm list-disc list-inside"
}

import { watch, computed } from 'vue'
import themeService from '../../../services/theme/themeService'


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    show: { type: Boolean },
    message: {},
    type: {},
    details: {},
    duration: {}
  },
  emits: ["update:show"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const isDarkMode = computed(() => themeService.isDark.value)

const emit = __emit

const handleClose = () => {
  emit('update:show', false)
}

// Auto-hide toast after duration
watch(
  () => props.show,
  (newValue) => {
    if (newValue && props.duration) {
      setTimeout(() => {
        emit('update:show', false)
      }, props.duration)
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["fixed top-4 right-4 z-50 flex items-center p-4 rounded-lg shadow-lg transition-all duration-300 transform", [
      _ctx.type === 'error'
        ? isDarkMode.value
          ? 'bg-red-900 text-red-100 border border-red-800'
          : 'bg-red-50 text-red-700 border border-red-100'
        : isDarkMode.value
          ? 'bg-green-900 text-green-100 border border-green-800'
          : 'bg-green-50 text-green-700 border border-green-100',
      _ctx.show ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
    ]])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.type === 'error')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[1] || (_cache[1] = [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ])))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1),
          (_ctx.details && _ctx.details.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(detail), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "ml-4 flex-shrink-0 text-sm opacity-75 hover:opacity-100 focus:outline-none",
          onClick: handleClose
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "currentColor",
            viewBox: "0 0 20 20"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ], -1)
        ]))
      ], 2))
    : _createCommentVNode("", true)
}
}

})